import { render, staticRenderFns } from "./paper-import-parse.vue?vue&type=template&id=ec09f49a&scoped=true&"
import script from "./paper-import-parse.vue?vue&type=script&lang=js&"
export * from "./paper-import-parse.vue?vue&type=script&lang=js&"
import style0 from "./paper-import-parse.vue?vue&type=style&index=0&id=ec09f49a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec09f49a",
  null
  
)

export default component.exports